import { LOCALE, THomeCategoryItem } from 'interfaces/types'

/**
 * TODO: Migrate data to CMS system
 * * Hardcode category data for MVP base on ticket (https://hhgdev.atlassian.net/browse/VP-66)
 */

export type topSectionSupported =
  | LOCALE.Vietnam
  | LOCALE.Malaysia
  | LOCALE.Indonesia

export type LinkMap = {
  vaccinations: string
  ivf: string
  eggFreezing: string
  pregnancy: string
  parenting: string
  healthyEating: string
  skinHealth: string
  healthyMind: string
  sexualWellness: string
  all: string
}

export type MapLink = {
  [K in topSectionSupported]: LinkMap
}

const MAP_LINK: MapLink = {
  [LOCALE.Vietnam]: {
    vaccinations: '/care/dich-vu/tiem-chung/',
    ivf: '/care/dich-vu/thu-tinh-ong-nghiem/',
    eggFreezing: '/care/dich-vu/dong-lanh-trung/',
    pregnancy: '/mang-thai/',
    parenting: '/nuoi-day-con/',
    healthyEating: '/an-uong-lanh-manh/',
    skinHealth: '/da-lieu/',
    healthyMind: '/tam-ly-tam-than/',
    sexualWellness: '/suc-khoe-tinh-duc/',
    all: '/categories/',
  },
  [LOCALE.Malaysia]: {
    vaccinations: '/care/vaccination/',
    ivf: '/care',
    eggFreezing: '/care',
    pregnancy: '/kehamilan/',
    parenting: '/keibubapaan/',
    healthyEating: '/pemakanan/',
    skinHealth: '/sihat-bergaya/',
    healthyMind: '/kesihatan-mental/',
    sexualWellness: '/seks-hubungan/',
    all: '/categories/',
  },
  [LOCALE.Indonesia]: {
    vaccinations: '/care/vaccination/',
    ivf: '/care',
    eggFreezing: '/care',
    pregnancy: '/kehamilan/',
    parenting: '/parenting/',
    healthyEating: '/nutrisi/',
    skinHealth: '/penyakit-kulit/',
    healthyMind: '/mental/',
    sexualWellness: '/seks/',
    all: '/categories/',
  },
}

export const homepageCategories = (
  locale: topSectionSupported,
): THomeCategoryItem[] => {
  const mapLink = MAP_LINK[locale]

  return [
    {
      id: 'home.category.vaccination',
      defaultMessage: 'Vaccination',
      icon: '/homepage-category/vaccination.png',
      href: mapLink.vaccinations,
      isNew: true,
    },
    {
      id: 'home.category.ivf',
      defaultMessage: 'IVF',
      icon: '/homepage-category/ivf.png',
      href: mapLink.ivf,
      isNew: true,
      hiddenLocale: [LOCALE.Malaysia, LOCALE.Indonesia],
    },
    {
      id: 'home.category.eggFreezing',
      defaultMessage: 'Egg Freezing',
      icon: '/homepage-category/eggFreezing.png',
      href: mapLink.eggFreezing,
      isNew: true,
      hiddenLocale: [LOCALE.Malaysia, LOCALE.Indonesia],
    },
    {
      id: 'home.category.pregnancy',
      defaultMessage: 'Pregnancy',
      icon: '/homepage-category/pregnancy.png',
      href: mapLink.pregnancy,
    },
    {
      id: 'home.category.parenting',
      defaultMessage: 'Parenting',
      icon: '/homepage-category/parenting.png',
      href: mapLink.parenting,
    },
    {
      id: 'home.category.nutrition',
      defaultMessage: 'Nutrition',
      icon: '/homepage-category/nutrition.png',
      href: mapLink.healthyEating,
    },
    {
      id: 'home.category.skincare',
      defaultMessage: 'Skincare',
      icon: '/homepage-category/skincare.png',
      href: mapLink.skinHealth,
      hiddenLocale: [LOCALE.Vietnam],
    },
    {
      id: 'home.category.mentalHealth',
      defaultMessage: 'Mental Health',
      icon: '/homepage-category/mentalHealth.png',
      href: mapLink.healthyMind,
    },
    {
      id: 'home.category.sexualWellness',
      defaultMessage: 'Sexual Wellness',
      icon: '/homepage-category/sexualWellness.png',
      href: mapLink.sexualWellness,
      hiddenLocale: [LOCALE.Vietnam],
    },
    {
      id: 'home.seeAllCategories',
      defaultMessage: 'allCategories',
      icon: '/homepage-category/allCategories.png',
      href: mapLink.all,
    },
  ].filter((item) => {
    if (item.hiddenLocale) {
      return !item.hiddenLocale.includes(locale)
    }
    return true
  })
}
